// Registers the offline service worker in production builds, scoped to
// /offline only (no trailing slash: a scope is a path prefix, and
// /offline/ would not cover the /offline URL itself). A worker that controls a page is consulted for every
// request that page makes, images included, and on iOS that alone changes
// how images load (back-nav flicker, measured 2026-10-21). So the normal
// app runs with no worker at all; only /offline and /offline/read/... are
// served without network. A new build takes over on the next load; we do
// not interrupt the reader mid-page.
const SCOPE = '/offline';

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      // Earlier builds registered at the root; that worker keeps
      // controlling every page until it is gone.
      .then((regs) => Promise.all(regs.filter((r) => new URL(r.scope).pathname !== SCOPE).map((r) => r.unregister())))
      .then(() => navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`, { scope: SCOPE }))
      .then((reg) => {
        reg.onupdatefound = () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.onstatechange = () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              // New version waiting; activate it so the next navigation gets it.
              sw.postMessage({ type: 'SKIP_WAITING' });
            }
          };
        };
      }).catch((e) => console.error('service worker registration failed', e));
  });
}
